import React, { memo, useEffect } from "react";
import { useState } from "react";
import { withRouter } from "react-router";
import ConfirmacionDialog from "../../../../../../components/Extra/ConfirmacionDialog";

// MATERIAL
import { makeStyles } from "@mui/styles";
import {
  Autocomplete,
  Box,
  FormControl,
  IconButton,
  Popper,
  TableCell,
  TableRow,
  TextField,
  Tooltip,
} from "@mui/material";
import { Cancel, Check, Create, Delete } from "@mui/icons-material";
import clienteAxios from "../../../../../../config/axios";
import { useContext } from "react";
import AlertaContext from "../../../../../../Context/Alerta/AlertaContext";

const useRowStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      borderBottom: ".5px solid #ccc",
    },
  },
  celda: {
    fontSize: ".7rem !important",
    "&:hover": {
      opacity: ".7",
      cursor: "pointer",
    },
  },
  active: {
    borderBottom: "5px solid #ccc",
    backgroundColor: "#354046",
  },
  color: {
    color: "white",
    margin: "0px",
    padding: "50px",
  },
}));

const RowArma = (props) => {
  const { mostrarAlerta } = useContext(AlertaContext);
  const { row, index, item, setitem, deshabilitarbotones } = props;
  const [itemRow, setItemRow] = useState(row);
  const [parametrosHData, setparametrosHData] = useState([]);
  const PopperMy = function (props) {
    return (
      <Popper {...props} style={useRowStyles.popper} placement="bottom-start" />
    );
  };
  useEffect(() => {
    setItemRow(row);
    // eslint-disable-next-line
  }, [item]);
  const classes = useRowStyles();
  const handleChange = (e) => {
    setItemRow({ ...itemRow, [e.target.name]: e.target.value });
  };
  const handleEliminar = async (_id) => {
    setitem({
      ...item,
      hospParametros: {
        parametrosCabecera: item.hospParametros.parametrosCabecera.filter(
          (itemFilter, itemIndex) => {
            return row.order !== itemFilter.order;
          }
        ),
        parametrosHorario: item.hospParametros.parametrosHorario.filter(
          (itemFilter, itemIndex) => {
            return row.order !== itemFilter.order;
          }
        ),
      },
    });
  };
  const funcionEdit = () => {
    seteditar(true);
  };
  const [editar, seteditar] = useState(false);
  const funcCancel = () => {
    setItemRow(row);
    seteditar(false);
  };
  const botonDisabled = () => {
    if (itemRow.nombre === "" || itemRow.valor === "") {
      return true;
    } else {
      return false;
    }
  };
  const funcSubmit = () => {
    setitem({
      ...item,
      hospParametros: {
        parametrosCabecera: item.hospParametros.parametrosCabecera.map(
          (itemFiltermedicamentosCabecera, itemIndex) => {
            if (itemRow.order === itemFiltermedicamentosCabecera.order) {
              return itemRow;
            } else {
              return itemFiltermedicamentosCabecera;
            }
          }
        ),
        parametrosHorario: item.hospParametros.parametrosHorario.map(
          (itemFiltermedicamentosHorario, itemIndex) => {
            if (itemRow.order === itemFiltermedicamentosHorario.order) {
              return {
                ...itemFiltermedicamentosHorario,
                nameParametrosHorarios: itemRow.parametro,
              };
            } else {
              return itemFiltermedicamentosHorario;
            }
          }
        ),
      },
    });
    seteditar(false);
  };
  const [openConfirmDialog, setopenConfirmDialog] = useState(false);
  return (
    <React.Fragment>
      <ConfirmacionDialog
        open={openConfirmDialog}
        setopen={setopenConfirmDialog}
        titulo="¿Esta seguro que quiere eliminar este Registro?"
        _id={itemRow._id}
        funcion={handleEliminar}
      />

      <TableRow className={classes.root} selected={index % 2 === 0}>
        {/* boton */}

        <TableCell
          size="small"
          padding="checkbox"
          style={{
            borderRight: "1px solid #ccc",
          }}
        >
          <Box display="flex" alignItems="center" justifyContent="center">
            {editar ? (
              <>
                <Tooltip title="Cancelar">
                  <IconButton
                    size="small"
                    onClick={() => {
                      funcCancel();
                    }}
                  >
                    <Cancel fontSize="small" color="secondary" />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Confirmar">
                  <IconButton
                    size="small"
                    disabled={botonDisabled ? botonDisabled() : false}
                    onClick={() => {
                      funcSubmit();
                    }}
                  >
                    <Check
                      fontSize="small"
                      color={
                        botonDisabled
                          ? botonDisabled()
                            ? "inherit"
                            : "secondary"
                          : "secondary"
                      }
                    />
                  </IconButton>
                </Tooltip>
              </>
            ) : (
              <>
                {" "}
                <Tooltip title="Eliminar">
                  <IconButton
                    size="small"
                    disabled={deshabilitarbotones}
                    onClick={() => {
                      setopenConfirmDialog(true);
                    }}
                  >
                    <Delete
                      fontSize="small"
                      color={deshabilitarbotones ? "inherit" : "error"}
                    />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Editar">
                  <IconButton
                    size="small"
                    color={deshabilitarbotones ? "inherit" : "secondary"}
                    disabled={deshabilitarbotones}
                    onClick={() => {
                      funcionEdit();
                    }}
                  >
                    <Create />
                  </IconButton>
                </Tooltip>
              </>
            )}
          </Box>
        </TableCell>

        {editar ? (
          <>
            <TableCell
              checkbox
              size="small"
              align="center"
              className={classes.celda}
            >
              <FormControl fullWidth>
                <Autocomplete
                  filterOptions={(x) => x}
                  PopperComponent={PopperMy}
                  options={parametrosHData.map((item) => {
                    return (
                      item.paramNombre +
                      "/+/" +
                      item.paramValor +
                      "/+/" +
                      item.paramId
                    );
                  })}
                  getOptionLabel={(option) => {
                    return option.replace("/+/", " ** ").split("/+/")[0];
                  }}
                  id="controlled-demo"
                  value={itemRow.parametro}
                  paperprops
                  onChange={async (event, newValue) => {
                    if (newValue) {
                      const options = newValue.split("/+/");
                      const itemF = parametrosHData.find((itemPersona) => {
                        return itemPersona.paramId === Number(options[2]);
                      });

                      setItemRow({
                        ...itemRow,
                        parametro: itemF.paramNombre,
                        dosis: itemF.paramValor,
                      });
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      size="small"
                      fullWidth
                      onChange={async (e) => {
                        if (e.target.value === "") {
                          return;
                        }
                        try {
                          const res = await clienteAxios.get(
                            `/parametros/filtro/0?search=${e.target.value}`
                          );
                          if (!res.data.data) {
                            return mostrarAlerta(res.data.msg, "error");
                          }

                          setparametrosHData(res.data.data);
                        } catch (error) {}
                      }}
                      // InputProps={{
                      //   ...params.InputProps,
                      //   endAdornment: (
                      //     <React.Fragment>
                      //       {!editar ? (
                      //         <IconButton
                      //           size="small"
                      //           aria-label=""
                      //           onClick={async () => {
                      //             seteditarProveedor(false);
                      //             setopenProveedor(true);
                      //           }}
                      //         >
                      //           <AddCircleOutlineTwoTone color="primary" />
                      //         </IconButton>
                      //       ) : null}
                      //       {params.InputProps.endAdornment}
                      //     </React.Fragment>
                      //   ),
                      // }}
                    />
                  )}
                />
              </FormControl>
            </TableCell>
            <TableCell
              checkbox
              size="small"
              align="center"
              className={classes.celda}
            >
              <TextField
                name="dosis"
                value={itemRow.dosis}
                onChange={(e) => handleChange(e)}
                size="small"
                fullWidth
              />
            </TableCell>

            <TableCell
              checkbox
              size="small"
              align="center"
              className={classes.celda}
            >
              <TextField
                type={"number"}
                name="inicio"
                value={itemRow.inicio}
                onChange={(e) => {
                  setItemRow({
                    ...itemRow,
                    inicio:
                      e.target.valueAsNumber > 23
                        ? 23
                        : e.target.valueAsNumber < 0
                        ? 0
                        : e.target.valueAsNumber,
                  });
                }}
                size="small"
                fullWidth
              />
            </TableCell>
            <TableCell
              checkbox
              size="small"
              align="center"
              className={classes.celda}
            >
              <TextField
                type={"number"}
                name="frecuencia"
                value={itemRow.frecuencia}
                onChange={(e) => {
                  setItemRow({
                    ...itemRow,
                    frecuencia:
                      e.target.valueAsNumber < 1
                        ? 1
                        : e.target.valueAsNumber > 23
                        ? 23
                        : e.target.valueAsNumber,
                  });
                }}
                size="small"
                fullWidth
              />
            </TableCell>
          </>
        ) : (
          <>
            <TableCell
              checkbox
              size="small"
              align="center"
              className={classes.celda}
            >
              {itemRow.parametro}
            </TableCell>
            <TableCell
              checkbox
              size="small"
              align="center"
              className={classes.celda}
            >
              {itemRow.dosis}
            </TableCell>

            <TableCell
              padding="checkbox"
              size="small"
              align="center"
              className={classes.celda}
            >
              {itemRow.inicio}
            </TableCell>
            <TableCell
              padding="checkbox"
              size="small"
              align="center"
              className={classes.celda}
            >
              {itemRow.frecuencia}
            </TableCell>
          </>
        )}
      </TableRow>
    </React.Fragment>
  );
};

export default withRouter(memo(RowArma));
